import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'role'
})
export class RolePipe implements PipeTransform {
   roles = new Map();

   constructor() {
    this.roles.set('ROLE_USER', 'User')
    this.roles.set('ROLE_ADMIN', 'Admin')
    this.roles.set('ROLE_SYS_ADMIN', 'System Admin')
   }


  transform(value: string[] | null | undefined): string {

    let result = '';
    
    for(let item of value!) {
      result+=this.roles.get(item) + ' '
    }
    return result; 
  }
}
